// extracted by mini-css-extract-plugin
export default {"container":"Trends_container__65pNt"};